var _radialGradient, _radialGradient2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAverageInteractionDistribution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 129,
    viewBox: "0 0 332 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f7ud58j81a",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1 0 0 1 1 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "1cu5nmihhc",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c7de1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff",
    stopOpacity: 0.502
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "8nd4ktec0b"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2859",
    width: 332,
    height: 129,
    rx: 16,
    style: {
      fill: "url(#f7ud58j81a)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Insight Card Inside Graphic",
    style: {
      clipPath: "url(#8nd4ktec0b)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 7",
    d: "M77.505 0a78.08 78.08 0 0 0-15.62 1.575 77.081 77.081 0 0 0-27.714 11.662 77.731 77.731 0 0 0-28.08 34.1 77.115 77.115 0 0 0-4.516 14.548 78.265 78.265 0 0 0-.028 31.1A77.071 77.071 0 0 0 13.009 120.5a77.742 77.742 0 0 0 33.569 28.093 77.116 77.116 0 0 0 14.344 4.638A77.942 77.942 0 0 0 76.337 155V77.503a1.16 1.16 0 0 1 .014-.177 1.148 1.148 0 0 1 .126-.377 1.171 1.171 0 0 1 .34-.39 1.167 1.167 0 0 1 .688-.225 1.257 1.257 0 0 1 .177.013 1.186 1.186 0 0 1 .195.048L151.9 99.312A77.46 77.46 0 0 0 77.505 0zm1.168 79.089V155a77.573 77.573 0 0 0 72.536-53.455L78.673 79.089z",
    transform: "rotate(180 172.002 81.5)",
    style: {
      fill: "url(#1cu5nmihhc)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageInteractionDistribution);
export default __webpack_public_path__ + "static/media/average-interaction-distribution.2e77a43493dccbf6efec1ee631b911c0.svg";
export { ForwardRef as ReactComponent };